<template>
  <div>
    <el-row :gutter="20" id="padding_input">
      <el-col :span="12" :offset="6"> 上传后台 </el-col>
    </el-row>
    <el-row :gutter="20" id="padding_input">
      <el-col :span="12" :offset="6">
        <el-input v-model="inputName" placeholder="email_address" clearable autocomplete="on"></el-input>
      </el-col>
    </el-row>
    <el-row :gutter="20" id="padding_input">
      <el-col :span="12" :offset="6">
        <el-input v-model="inputPass" placeholder="password" show-password clearable autocomplete="new-password"></el-input>
      </el-col>
    </el-row>
    <el-row :gutter="20" id="padding_input">
      <el-col :span="12" :offset="6">
        <el-button type="primary" @click="login">点击登录</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputName: "",
      inputPass: "",
    };
  },
  methods: {
    login() {
      var api = "/login/";
      this.axios
        .post(
          api,
          this.$qs.stringify({
            name: this.inputName,
            password: this.inputPass,
          })
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.code == 200) {
            this.$message(response.data.message);
            this.$cookies.set("token", response.data.data.token);
            this.axios.defaults.headers.common["Authorization"] =
              response.data.data.token;
            this.$emit("refresh");
          } else {
            this.$message.error(response.data.message);
          }
        });
    },
  },
};
</script>

<style>
#padding_input {
  padding-top: 20px;
}
</style>